import JSONAPISerializer from "@ember-data/serializer/json-api";
import { service } from "@ember/service";
import type SemeiaSessionService from "parog-web/services/session";

type PatientChatMessagePayload = {
  data: {
    attributes: Record<string, string | null>;
  };
};

export default class extends JSONAPISerializer {
  @service declare session: SemeiaSessionService;

  override serialize(snapshot, options) {
    const json = super.serialize(
      snapshot,
      options
    ) as PatientChatMessagePayload;

    delete json.data.attributes["read-by-patient-at"];
    delete json.data.attributes["created-at"];
    delete json.data.attributes["updated-at"];
    delete json.data.attributes["occurred-at-offset-in-seconds"];

    return json;
  }
}
